import React from "react"
import { useStore } from "../../teafuljs/store"
import scrollToElement from "scroll-to-element"
import { makeStyles } from "@material-ui/core/styles"
import SourceIcons from "../../data/SourceIcons.json"
import Button from "@material-ui/core/Button"
import Divider from "@material-ui/core/Divider"
import LinearProgress from "@material-ui/core/LinearProgress"
import GetSegment from "../../scripts/NavigateToSegment"
import bibleBookList from "../../data/BookChapterList.json"
import { getTranslation } from "../../scripts/getTranslation"
import { recordEvent } from "../../apis/googleAnalytics"

const useStyles = makeStyles({
  recipient: {
    display: "flex",
    justifyContent: "space-between",
    margin: "10px 0 10px 0",
  },
  SVicons: {
    height: "20px",
    width: "20px",
    margin: 0,
  },
  blackButton: {
    color: "black",
    backgroundColor: "rgb(201, 201, 201)",
    borderColor: "black",
    margin: "2px",
  },
  redButton: {
    color: "#d60000",
    backgroundColor: "#ffadad",
    borderColor: "#d60000",
    margin: "2px",
  },
  greenButton: {
    color: "#006400",
    backgroundColor: "#b9f8b9",
    borderColor: "#006400",
    margin: "2px",
  },
  blueButton: {
    color: "darkblue",
    backgroundColor: "rgb(142, 227, 255)",
    borderColor: "darkblue",
    margin: "2px",
  },
  links: {
    margin: 0,
  },
  recipName: {
    margin: 0,
    textAlign: "right",
    // flex: '0 1 200px'
  },
  wordCountDiv: {
    display: "flex",
    justifyContent: "space-between",
  },
  line: {
    flex: 4,
    margin: "auto 0",
  },
  wordCount: {
    fontSize: "70%",
    color: "grey",
    textAlign: "right",
    flex: 1,
    margin: 0,
  },
})

export default function SourceMetadata(props) {
  const translations = useStore.translations()[0]
  const AvailableContent = useStore.AvailableContent()[0]
  const language = useStore.language()[0]
  const version = useStore.version()[0]
  const [history, setHistory] = useStore.history()
  const [searchID, setSearchID] = useStore.searchID()
  const [currentSegmentID, setCurrentSegmentID] = useStore.currentSegmentID()
  const [currentBook, setCurrentBook] = useStore.currentBook()
  const [refID, setRefID] = useStore.refID()
  const stateMetadata = useStore.metadata()[0]
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(null)
  const metadata =
    AvailableContent.version === 2
      ? stateMetadata[props.sourceName]
      : require(`../../data/SourceMetadata(${version}).json`)[props.sourceName]
  const recipients = Array.isArray(metadata.speaks_to)
    ? metadata.speaks_to
    : Object.values(metadata.speaks_to)
  const totalWords = recipients[0].wordCount

  function updateExpanded(name) {
    setExpanded(name)
  }

  async function navigateToRef(obj) {
    setHistory([
      {
        page: window.location.pathname,
        language: language,
        version: version,
        segment: currentSegmentID,
        scrollY: window.scrollY,
      },
      ...history,
    ])
    const segment = GetSegment(obj.book, obj.chapter, obj.verse)
    if (currentSegmentID === segment) {
      const elements = Array.from(
        document.querySelectorAll(
          `[verseref=ref-${obj.book}-${obj.chapter}-${obj.verse}]`
        )
      )
      const element = elements.find(
        el =>
          !el.getAttribute("data-verse") &&
          !(
            el.getAttribute("style") &&
            el.getAttribute("style").includes("display: none")
          )
      )
      scrollToElement(element, {
        offset: -65,
        ease: "inOutCube",
        duration: 1500,
      })
      props.close()
    } else {
      setCurrentSegmentID(segment)
      setCurrentBook(obj.book)
      setRefID("")
      setSearchID(`${obj.book}-${obj.chapter}-${obj.verse}`)
      props.close()
    }
  }
  function sortReferences(references) {
    const verseSortedRefs = sortBy("verse", references)
    console.log(verseSortedRefs.map(r => r.startRef))
    const chapterSortedRefs = sortBy("chapter", verseSortedRefs)
    console.log(chapterSortedRefs.map(r => r.startRef))
    const bibleBookOrder = Object.keys(bibleBookList)
    chapterSortedRefs.sort(function(a, b) {
      return (
        bibleBookOrder.indexOf(a.startRef.book) -
        bibleBookOrder.indexOf(b.startRef.book)
      )
    })
    console.log(chapterSortedRefs.map(r => r.startRef))
    return chapterSortedRefs
  }

  function sortBy(dataPoint, references) {
    references.sort(function(a, b) {
      return +a.startRef[dataPoint] - +b.startRef[dataPoint]
    })
    return references
  }

  return (
    <div>
      <p>
        {getTranslation(
          translations,
          language,
          "Sources",
          props.sourceName
        )}{" "}
        {getTranslation(
          translations,
          language,
          "UI",
          "sourceview_popup_spokeTo"
        )}
      </p>
      {recipients.map((recip, index) => {
        if (!SourceIcons[recip.recipient]) {
          console.log(recip.recipient)
          return null
        } else {
          return (
            <React.Fragment key={index}>
              <div
                onClick={() =>
                  updateExpanded(
                    expanded === recip.recipient ? null : recip.recipient
                  )
                }
              >
                <div className={classes.recipient}>
                  <img
                    src={require(`../../../static/images/${
                      SourceIcons[recip.recipient].sourceIcon
                    }.png`)}
                    className={classes.SVicons}
                    alt="Source Name"
                  />
                  <p className={classes.recipName}>
                    {getTranslation(
                      translations,
                      language,
                      "Sources",
                      recip.recipient
                    )}
                  </p>
                </div>
                <div className={classes.wordCountDiv}>
                  <LinearProgress
                    className={classes.line}
                    color="primary"
                    variant="determinate"
                    value={Math.min((recip.wordCount / totalWords) * 100)}
                  />
                  <p className={classes.wordCount}>
                    ({recip.wordCount.toLocaleString()})
                  </p>
                </div>
              </div>
              {expanded === recip.recipient ? (
                <div className={classes.links}>
                  {sortReferences(recip.references).map((refLink, index) => {
                    return (
                      <Button
                        size="small"
                        className={classes[`${refLink.color}Button`]}
                        onClick={() => {
                          recordEvent(
                            "Source Occurrence Navigation",
                            `${language}-${version}`,
                            `${props.sourceName}: ${refLink.startRef.book}-${refLink.startRef.chapter}-${refLink.startRef.verse}`
                          )
                          navigateToRef(refLink.startRef)
                        }}
                        key={index}
                      >
                        {getTranslation(
                          translations,
                          language,
                          "Books",
                          `abbrev_${refLink.startRef.book}`
                        )}{" "}
                        {refLink.startRef.chapter}: {refLink.startRef.verse}
                        {refLink.startRef !== refLink.endRef && refLink.endRef
                          ? `${
                              refLink.startRef.chapter !==
                              refLink.endRef.chapter
                                ? `-${refLink.endRef.chapter}: ${
                                    refLink.endRef.verse
                                  }`
                                : refLink.startRef.verse !==
                                  refLink.endRef.verse
                                ? `-${refLink.endRef.verse}`
                                : ""
                            }`
                          : null}
                      </Button>
                    )
                  })}
                </div>
              ) : null}
              <Divider />
            </React.Fragment>
          )
        }
      })}
    </div>
  )
}
